
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const onUpdate = (event: InputEvent) => {
            const target = event.target as HTMLInputElement
            const files = target.files

            const array_of_files: File[] = []

            if (!files || !files.length) {
                emit('update:value', array_of_files)
                emit('change', array_of_files)
                return
            }

            for (let index = 0; index < files.length; index++) {
                const file = files.item(index)
                if (!file) continue
                array_of_files.push(file)
            }

            emit('update:value', array_of_files)
            emit('change', array_of_files)

            target.value = ''
        }

        return {
            onUpdate,
        }
    },
})
